import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { DATE_FORMAT, useDateService } from 'framework/utils';

const GeneralStructureComplianceTrendChart = ({ averageTrendData }: any) => {
  const { formatDate } = useDateService();
  return (
    <Box
      sx={{
        p: 2,
        m: 2,
        pl: 4,
        backgroundColor: 'background.paper',
        borderRadius: 1,
        mb: 2,
        boxShadow: '0 2px 4px var(--mui-palette-common-shadowDefault)',
      }}
    >
      <Typography variant="h4" mb={2} color="primary">
        General structure compliance trend
      </Typography>
      <Box height="400px">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={averageTrendData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: 12 }} interval={0} />
            <YAxis tick={{ fontSize: 12 }} domain={[0, 100]} unit="%" width={20} />
            <ChartTooltip
              formatter={(value: number) => [`${value}%`, 'Average fulfillment']}
              labelFormatter={date => {
                return formatDate(date as string, DATE_FORMAT.FULL_DATE);
              }}
            />

            <Area
              type="monotone"
              dataKey="averagePercentage"
              stroke="var(--mui-palette-primary-main)"
              fill="var(--mui-palette-primary-main)"
              fillOpacity={0.6}
              strokeWidth={2}
              name="Average fulfillment"
            />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default GeneralStructureComplianceTrendChart;
